import { fetchPersonEmails } from '../../../../services/queries/MaggieCompanyQueries';

export const createUpdatePersonEmail = (personId: number) => {
  const handleUpdateEmail = async () => {
    return await fetchPersonEmails(personId);
  };

  return { handleUpdateEmail };
};
